import { useTranslation } from 'react-i18next';
import IncTextField from '../fields/inc-text-field/inc-text-field.component';

const EmailTemplateForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <IncTextField
        name="name"
        label={t('forms.emailTemplateForm.fields.emailTemplateName.label')}
        helperText={t(
          'forms.emailTemplateForm.fields.emailTemplateName.helperText',
        )}
        data-testid="EmailTemplateForm.IncTextField.emailTemplateName"
      />
      <IncTextField
        name="subject"
        label={t('forms.emailTemplateForm.fields.subject.label')}
        helperText={t('forms.emailTemplateForm.fields.subject.helperText')}
        data-testid="EmailTemplateForm.IncTextField.subject"
      />
    </>
  );
};

export default EmailTemplateForm;
